import angular from 'angular';

angular
  .module('cxTaskflow')
  .controller('InvoiceMethodChangedDialogCtrl', [
    '$element',
    '$filter',
    'close',
    'advances',
    invoiceMethodChangedDialogCtrl,
  ]);

function invoiceMethodChangedDialogCtrl($element, $filter, close, advances) {
  var vm = this;
  vm.advances = {
    count: advances.count || 0,
    amount: $filter('dynCurrency')(advances.amount || 0),
  };
  vm.save = function(removeAdvances) {
    $element.modal('hide');
    close(removeAdvances, 500);
  };

  vm.cancel = function() {
    $element.modal('hide');
    close(null, 500);
  };
}
